function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pfx11643__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 0 0.890196 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v21.574c16.399 0 29.695 3.485 29.695 7.785v43.97C29.695 77.63 16.4 83.616 0 83.616L.058 91H73V0",
  id: "pfx11643__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.14 0L.968.221 0 87.531l17.075 8.608V51.363c0 4.3 13.325 7.784 29.76 7.784 16.438 0 29.762-3.485 29.762-7.784V95.33l29.753.845L98.14 0z",
  id: "pfx11643__d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.14 0L.968.221 0 87.531l17.075 8.608V51.363c0 4.3 13.325 7.784 29.76 7.784 16.438 0 29.762-3.485 29.762-7.784V95.33l29.753.845L98.14 0z",
  id: "pfx11643__f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.14 0L.968.221 0 87.531l17.075 8.608V51.363c0 4.3 13.325 7.784 29.76 7.784 16.438 0 29.762-3.485 29.762-7.784V95.33l29.753.845L98.14 0z",
  id: "pfx11643__h"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.14 0L.968.221 0 87.531l17.075 8.608V51.363c0 4.3 13.325 7.784 29.76 7.784 16.438 0 29.762-3.485 29.762-7.784V95.33l29.753.845L98.14 0z",
  id: "pfx11643__j"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(156 29)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-52.98 -24.3)",
  filter: "url(#pfx11643__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.98 96.297c6-41-26-55-25.754-77 .246-22 33-24 45-12s19 18 38 41 51-6 35-21-51 9-78 4-9-39 16-25 50 66 24 100-108 12-116-27",
  stroke: "#E84A32",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(163 21.299 42.333)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E84A32",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.527 4.857)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 5.08 4.235)",
  d: "M2.888 8.864L7.272 -0.394"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 8.187 13.798)",
  d: "M9.914 18.619L6.459 8.977"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 16.403 19.587)",
  d: "M21.112 21.613L11.694 17.561"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 27.242 13.95)",
  d: "M31.353 10.891L23.13 17.01"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 29.865 2.526)",
  d: "M30.517 -2.553L29.212 7.604"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.974 16.332L4 18.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.974 19.332L0.375 19.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.668 23.801L17.502 27.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.668 0.801L30.502 4.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.075 21L33.388 25.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.075 29L35.375 29.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.075 0L21.388 4.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.341 12.426L40.424 13.399"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.341 14.426L46.375 14.632"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E84A32",
  cx: 26.875,
  cy: 10.132,
  r: 1
}))), /*#__PURE__*/React.createElement("path", {
  d: "M66 60c0 4.419-13.655 8-30.5 8S5 64.419 5 60c0-4.419 13.655-8 30.5-8S66 55.581 66 60",
  fill: "#544D44"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.3 30.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx11643__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx11643__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.914 23.849c3.364-2.637 14.24 5.832 24.296 18.916 10.056 13.083 15.481 25.826 12.117 28.462-3.363 2.637-14.24-5.832-24.297-18.916C13.974 39.228 8.55 26.485 11.914 23.849",
  fill: "#544D44",
  mask: "url(#pfx11643__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.417 66.454l-6.09 4.773c3.365-2.637-2.06-15.38-12.116-28.462-10.056-13.083-20.934-21.553-24.297-18.917l6.09-4.772c3.363-2.637 14.241 5.832 24.297 18.916 10.056 13.082 15.48 25.825 12.116 28.462",
  fill: "#CAC5B8",
  mask: "url(#pfx11643__c)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 60)",
  fill: "#CAC5B8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 44.542V12c0 4.372 13.655 7.915 30.5 7.915S61 16.372 61 12v32.542C61 48.914 47.345 55 30.5 55S0 48.914 0 44.542"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8V0c0 4.419 13.655 8 30.5 8S61 4.419 61 0v8c0 4.419-13.655 8-30.5 8S0 12.419 0 8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-11 9)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx11643__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx11643__d"
})), /*#__PURE__*/React.createElement("path", {
  d: "M28.105 28.69c.104.603.682 1.012 1.278.906l6.086-1.071a1.116 1.116 0 0 0 .897-1.288 1.11 1.11 0 0 0-1.278-.906l-6.084 1.072a1.117 1.117 0 0 0-.9 1.288zm5 4.312c.985-.173 2.011-.839 1.816-1.959l-.143-.836-4.188.736c.167.965.192 1.876 1.56 2.08.302.046.628.037.954-.02zm-3.733-21.55c-3.625.637-6.05 4.116-5.417 7.769.551 3.174 3.19 4.387 4.91 6.646l5.824-1.025c.862-2.719 2.946-4.746 2.395-7.932-.635-3.653-4.086-6.096-7.712-5.459zM27.84 7.073c-.172-.997 1.33-1.261 1.503-.265l.169.975c.172.997-1.33 1.261-1.504.265l-.168-.975zm6.019.14c.345-.946 1.772-.42 1.428.53l-.336.928c-.346.947-1.775.42-1.43-.529l.338-.928zM39 10.37c.768-.645 1.74.53.972 1.175l-.754.634c-.765.645-1.74-.528-.971-1.175l.753-.634zm2.885 5.32c.985-.173 1.246 1.335.262 1.51l-.968.17c-.985.173-1.246-1.335-.262-1.508l.968-.171zm-.142 6.063c.94.344.418 1.782-.52 1.438l-.921-.34c-.942-.346-.42-1.782.517-1.438l.924.34zM22.56 9.983c-.645-.773.522-1.76 1.165-.986l.631.76c.644.774-.525 1.757-1.166.985l-.63-.759zm-3.132 5.178c-.94-.348-.417-1.786.525-1.44l.921.34c.94.348.417 1.788-.524 1.44l-.922-.34zm-.138 6.064c-.99.173-1.252-1.34-.263-1.515l.966-.17c.99-.173 1.252 1.34.263 1.515l-.966.17zm2.886 5.317c-.768.648-1.745-.527-.977-1.175l.752-.634c.769-.649 1.746.527.978 1.175l-.753.634zM29.11 9.937c4.455-.784 8.697 2.22 9.476 6.708.632 3.65-1.373 5.696-2.33 8.325a2.645 2.645 0 0 1 1.613 2.003 2.662 2.662 0 0 1-1.6 2.91l.156.896c.36 2.073-1.3 3.427-3.058 3.736-1.76.311-3.777-.396-4.135-2.472l-.156-.896a2.645 2.645 0 0 1-2.474-2.192 2.669 2.669 0 0 1 .836-2.427c-1.781-2.15-4.354-3.404-4.985-7.043-.778-4.488 2.202-8.762 6.657-9.548z",
  fill: "#CAC5B8",
  mask: "url(#pfx11643__e)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "pfx11643__g",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx11643__f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M62.301 50.333s3.546-8.707 3.546-17.86c0-9.971-17.726-23.217-17.726-23.217S30.395 22.502 30.395 32.474c0 9.152 3.545 17.86 3.545 17.86h28.361z",
  fill: "#EBEDE3",
  mask: "url(#pfx11643__g)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "pfx11643__i",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx11643__h"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E84A32",
  mask: "url(#pfx11643__i)",
  d: "M41.0297533 28.9017513L46.3481164 28.9017513 46.3481164 25.3295325 49.8936918 25.3295325 49.8936918 28.9017513 55.2102822 28.9017513 55.2102822 32.4739702 49.8936918 32.4739702 49.8936918 41.4027313 46.3481164 41.4027313 46.3481164 32.4739702 41.0297533 32.4739702z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "pfx11643__k",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx11643__j"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EBEDE3",
  mask: "url(#pfx11643__k)",
  d: "M33.9400207 59.2631113L62.3010784 59.2631113 62.3010784 53.904783 33.9400207 53.904783z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E84A32",
  mask: "url(#pfx11643__k)",
  d: "M33.9400207 53.9029969L62.3010784 53.9029969 62.3010784 50.3325641 33.9400207 50.3325641z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.141 34.788l.991-4.062c.23-.947-.501-1.95-1.63-2.23l-.67-.167-.744 1.354-.083-1.56-5.926-1.466-1.013 3.555-.173-.013.484-3.715-.515-.13-1.01 3.586-.174-.043.48-3.717c-1.1-.234-2.166.31-2.39 1.235l-.99 4.06 13.363 3.313zm-14.693 31.47c.672.165 1.082.85.915 1.524a1.245 1.245 0 0 1-1.512.922 1.26 1.26 0 0 1-.915-1.525 1.248 1.248 0 0 1 1.512-.92zm13.823-27.905L67.906 35.04c-.15.61-.296 1.22-.445 1.83 1.875.957 3.317 2.387 4.164 4.46-.963 3.952-8.274 24.573-6.898 27.532a2.56 2.56 0 0 0 3.973.879c2.464-2.074 5.426-23.655 6.378-27.558 1.706-1.438 3.644-2.03 5.746-2.002l.447-1.83zm-12.72-5.955l13.363 3.311-.485 1.992-13.365-3.313.487-1.99z",
  fill: "#CAC5B8",
  mask: "url(#pfx11643__k)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.097 61.655c-.087-.787.16-1.693.454-2.416.606.662 1.32 1.507 1.467 2.43.086.535.169 1.567-.391 1.908-1.199.733-1.447-1.175-1.53-1.922-.064-.573.24 2.156 0 0m-28.8-3.029c-2.306-3.02-3.476-6.87-3.274-10.674.195-3.675 1.596-7.251 4.654-9.443 3.455-2.475 8.295-2.763 11.936-.523a10.32 10.32 0 0 1 2.289 1.918 10.879 10.879 0 0 1 1.124 1.506c.083.13-.17.223-.27.321-1.336 1.324-.097 3.712 1.757 3.301.309-.068.241-.103.39.129l7.387 11.422c.156.241.1.166-.051.473-.42.861-.144 1.936.647 2.476.119.08.245.146.378.2.152.06.212.003.172.193a8.686 8.686 0 0 0-.133.762 5.514 5.514 0 0 0 0 1.41c.17 1.286.608 2.963 2.012 3.382 1.468.44 3.01-.462 3.427-1.912.576-2.004-.357-3.885-1.647-5.362 1.572-1.111.66-3.69-1.259-3.544-.335.025-.496.26-.679-.02-.126-.194-7.215-11.16-7.359-11.379-.032-.05-.152-.179-.154-.24 1.195-1.528-.43-3.729-2.22-3.029-.113.045-.232.176-.306.058-.045-.07-.339-.511-.445-.66a12.878 12.878 0 0 0-3.007-3.006 12.766 12.766 0 0 0-5.712-2.241c-4.189-.56-8.566.93-11.479 4.033-2.561 2.727-3.733 9.079-3.756 10.134-.135 5.459 2.27 10.987 6.502 14.436 9.4 7.235 7.547 11.279 1.988 12.835-5.56 1.555-14.635 2.145-16.048 3.517-1.586 1.541-1.124 3.14.03 4.07.687.554 3.372 1.77 4.076 1.956 2.85.748 2.993-1.288 1.55-1.752-2.356-.761-5.874-2.294-2.991-2.917 2.882-.622 8.545-1.452 11.633-1.97 3.088-.518 9.367-.414 9.47-5.808.103-5.393-7.88-11.403-10.631-14.052",
  fill: "#544D44",
  mask: "url(#pfx11643__k)"
})));

function SvgQ2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 146,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ2);
export default __webpack_public_path__ + "static/media/q2.27e3c721.svg";
export { ForwardRef as ReactComponent };